import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import { Loader } from '@pwc/pwc-deals-ui';

import DivestitureDiagnosticSidebarRouter from '../../common/components/DivestitureDiagnosticSidebar/DivestitureDiagnosticSidebarRouter';
import SurveyRouter from '../../Survey/components/SurveyRouter/SurveyRouter';
import {
  surveyRoute,
  contentResponsesRoute,
  formatSurveyRoute,
} from '../../Survey/routes';
import {
  getDivestitureDiagnosticResults,
  getFetchDivestitureDiagnosticResultsStatus,
  fetchDivestitureDiagnosticResults,
} from './divestitureDiagnosticSlice';
import { resultsRoute, formatResultsRoute } from './routes';
import SurveyWelcomeModal from '../../Survey/components/SurveyWelcomeModal/SurveyWelcomeModal';
import './DivestitureDiagnosticContent.scss';
import ResultsRouter from './ResultsRouter';
import ResponsesRouter from './ResponsesRouter';
import { resetQuestion } from '../../Survey/surveySlice';

const DivestitureDiagnosticContent = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const divestitureDiagnosticResults = useSelector(
    getDivestitureDiagnosticResults
  );
  const { pending: fetchDDPending } = useSelector(
    getFetchDivestitureDiagnosticResultsStatus
  );

  useEffect(() => {
    dispatch(fetchDivestitureDiagnosticResults(projectId));
    return () => dispatch(resetQuestion());
  }, [dispatch, projectId]);

  return (
    <>
      {fetchDDPending && <Loader />}
      <div className="divestiture-diagnostic-content-wrapper">
        {!fetchDDPending && (
          <>
            <SurveyWelcomeModal />
            <DivestitureDiagnosticSidebarRouter />
            <Switch>
              <Route path={contentResponsesRoute} exact>
                <div className="diagnostic-content-container">
                  <ResponsesRouter />
                </div>
              </Route>
              <Route path={resultsRoute}>
                <ResultsRouter />
              </Route>
              <Route path={surveyRoute}>
                <div className="diagnostic-content-container">
                  <SurveyRouter />
                </div>
              </Route>
              <Route>
                {!divestitureDiagnosticResults && (
                  <Redirect to={formatSurveyRoute(projectId)} />
                )}
                {divestitureDiagnosticResults && (
                  <Redirect to={formatResultsRoute(projectId)} />
                )}
              </Route>
            </Switch>
          </>
        )}
      </div>
    </>
  );
};

export default DivestitureDiagnosticContent;
